export default __webpack_public_path__ + "static/media/keukeneethoek.b6d548a5.jpg";